// import { useState, useEffect } from "react";
// import { keycloak } from "../auth/keycloakService";

// export function useUser() {
//   const [user, setUser] = useState(() => {
//     const token = keycloak.tokenParsed || {};
//     return {
//       info: token || null,
//       roles: token?.resource_access?.processcontrol?.roles || [],
//       attributes: extractAttributes(token),
//     };
//   });

//   useEffect(() => {
//     const updateUser = () => {
//       const token = keycloak.tokenParsed || {};
//       setUser({
//         info: token || null,
//         roles: token?.resource_access?.processcontrol?.roles || [],
//         attributes: extractAttributes(token),
//       });
//     };

//     if (keycloak.authenticated) {
//       updateUser();
//     }

//     keycloak.onAuthSuccess = updateUser;
//     keycloak.onAuthRefreshSuccess = updateUser;
//     keycloak.onAuthLogout = () =>
//       setUser({ info: {}, roles: [], attributes: {} });

//     return () => {
//       keycloak.onAuthSuccess = undefined;
//       keycloak.onAuthRefreshSuccess = undefined;
//       keycloak.onAuthLogout = undefined;
//     };
//   }, []);

//   return user;
// }

// // Utility to extract user-defined attributes from the root token
// function extractAttributes(token: Record<string, any>) {
//   const knownClaims = new Set([
//     "exp",
//     "iat",
//     "auth_time",
//     "jti",
//     "iss",
//     "aud",
//     "sub",
//     "typ",
//     "azp",
//     "nonce",
//     "session_state",
//     "acr",
//     "allowed-origins",
//     "realm_access",
//     "resource_access",
//     "scope",
//     "sid",
//     "email_verified",
//     "name",
//     "preferred_username",
//     "given_name",
//     "family_name",
//     "email",
//   ]);

//   const attributes: Record<string, any> = {};
//   for (const key in token) {
//     if (!knownClaims.has(key)) {
//       attributes[key] = token[key];
//     }
//   }
//   return attributes;
// }

import { useState, useEffect } from "react";
import { keycloak } from "../auth/keycloakService";

type Subject = {
  id: string;
  roles: string[];
  attributes: Record<string, any>;
};

export function useUser(): Subject {
  const [user, setUser] = useState<Subject>(() =>
    buildSubject(keycloak.tokenParsed || {})
  );

  useEffect(() => {
    const updateUser = () => {
      const token = keycloak.tokenParsed || {};
      setUser(buildSubject(token));
    };

    if (keycloak.authenticated) {
      updateUser();
    }

    keycloak.onAuthSuccess = updateUser;
    keycloak.onAuthRefreshSuccess = updateUser;
    keycloak.onAuthLogout = () =>
      setUser({ id: "", roles: [], attributes: {} });

    return () => {
      keycloak.onAuthSuccess = undefined;
      keycloak.onAuthRefreshSuccess = undefined;
      keycloak.onAuthLogout = undefined;
    };
  }, []);

  return user;
}

function buildSubject(token: Record<string, any>): Subject {
  const id = token.sub || "";
  const roles = token?.resource_access?.processcontrol?.roles || [];

  const attributes: Record<string, any> = {
    name: token.name,
    given_name: token.given_name,
    family_name: token.family_name,
    preferred_username: token.preferred_username,
    email: token.email,
    email_verified: token.email_verified,
    team: token.team,
    department: token.department,
    realm_roles: token.realm_access?.roles || [],
    resource_roles: token.resource_access || {},
    scope: token.scope,
    session_state: token.session_state,
    issuer: token.iss,
    audience: token.aud,
    allowed_origins: token["allowed-origins"],
  };

  // Known claim keys to exclude from dynamic extraction
  const knownClaims = new Set([
    "exp",
    "iat",
    "auth_time",
    "jti",
    "iss",
    "aud",
    "sub",
    "typ",
    "azp",
    "nonce",
    "session_state",
    "acr",
    "allowed-origins",
    "realm_access",
    "resource_access",
    "scope",
    "sid",
    "email_verified",
    "name",
    "preferred_username",
    "given_name",
    "family_name",
    "email",
    "team",
    "department",
  ]);

  // Add any remaining custom attributes
  for (const key in token) {
    if (!knownClaims.has(key)) {
      attributes[key] = token[key];
    }
  }

  // Remove undefined attributes
  Object.keys(attributes).forEach((key) => {
    if (attributes[key] === undefined) {
      delete attributes[key];
    }
  });

  return { id, roles, attributes };
}
